<template>
  <div class="item-base">
    <div class="choose-base">
      <rl-title :show-name="Sname"/>
      <div class="choose-content">
        <marquee behavior="scroll" direction="left" scrollamount="10">
          <img :src="'http://'+item.logoAddress" alt="" v-for="item in result" :key="item.id">
        </marquee>
      </div>
      <ripeav-more url-link="/choose" ripeav-more="查看更多" style="margin:  0 auto;text-align: center;"></ripeav-more>
    </div>
  </div>
</template>

<script>

import RipeavRightGo from "@/components/RipeavRightGo";
import RipeavMore from "../../components/RipeavMore";
import RlTitle from "@/components/Title";
export default {
  name: "HomeChoose",
  components: {RlTitle, RipeavMore, RipeavRightGo},
  data(){
    return{
      Data:{
        'pageNumber':0,
        'pageSize':40,
      },
      result:{},
      Sname:'他们选择了瑞普',
    }
  },
  created() {
    this.GetChooseData(this.Data)
  },
  methods:{
    GetChooseData(data){
      this.$axios.post('/api/cooperative/getAll',data).then(res=>{

        this.result=res.data.data.records
      })
    }

  }
}
</script>

<style lang="less" scoped>
.item-base{
  width: 100%;
  background: rgba(237,239,242,0.5);
  padding-bottom: 60px;
}
.choose-base{
  width: 74.5vw;
  min-height: 400px;
  margin: 0 auto;
  padding-bottom: 40px;
  position: relative;
  .choose-content{
    display: flex;
    /*flex-wrap: wrap;*/
    /*align-items: unset;*/
    justify-content: flex-start;
    width: 74.5vw;
    margin-bottom: 30px;
    img{
      width: 140px;
      height: 70px;
      /*margin-right: 15px;*/
      object-fit: cover;
      margin-bottom: 15px;
      margin-right: 20px;
    }
  }
}
</style>